import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './store/store';
import App from './App';
import './index.css';
import { getBasePath } from './utils/tenantDetection';
import { ThemeProvider } from './context/ThemeContext';

// Get the base path for the tenant (e.g., '/shilpani' for path-based tenants)
const basename = getBasePath();
if (basename) {
  console.log('🏢 Tenant URL detected - Router basename:', basename);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter basename={basename}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

